export const knowledgeManagerDBGroup = 'knowledge-manager';
//# sourceMappingURL=common.js.map